import AwardEntryWithWorks from '@/awards/models/AwardEntryWithWorks';
import RoleMembers from '@/awards/models/RoleMembers';
import AggregatedAwardEntry from '@/awards/models/AggregatedAwardEntry';
import WorkAsset from '@/awards/models/WorkAsset';
import CampaignAwards from './CampaignAwards';

class CampaignResult {
  campaignTitles = [];

  workEntries = [];
  
  campaignAwards = [];

  aggregatedTeams = [];

  aggregatedEntry = null;

  assets = [];

  constructor(campaignResult) {
    this.campaignTitles = campaignResult.campaignTitles;
    this.workEntries = AwardEntryWithWorks.fromObjectList(campaignResult.workEntries);
    this.campaignAwards = CampaignAwards.fromObjectList(campaignResult.campaignAwards);
    this.aggregatedTeams = RoleMembers.fromObjectList(campaignResult.aggregatedTeams);
    this.aggregatedEntry = AggregatedAwardEntry.fromObject(campaignResult.aggregatedAwardEntry);
    this.assets = WorkAsset.fromObjectList(campaignResult.assets);
  }

  getWorkEntryDetails(awardEntrySelectedSetId) {
    if (!this.workEntries || this.workEntries.length === 0) {
      return null;
    }

    return this.workEntries.find((entry) => entry?.awardEntry?.selectedSetId === awardEntrySelectedSetId);
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }

    return new CampaignResult(data);
  }
}

export default CampaignResult;
